module.exports = __webpack_public_path__ + "static/media/az.3bbb7a77.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/az.svg
// module id = 2040
// module chunks = 0